module.exports = __webpack_public_path__ + "480a6cfe1f58e7001aba3caa83c40fc3.svg";